import RegistrationModalContainer from './RegistrationModalContainer';

export default RegistrationModalContainer;
